import React from 'react';
import { useDarkMode } from '../../contexts/DarkModeContext';
import { FaGooglePlay, FaApple, FaRocket, FaGraduationCap, FaUsers, FaBrain, FaGlobe, FaDownload, FaStar, FaCheck } from 'react-icons/fa';
import './MobileAdsStore.css';

const MobileAdsStore = () => {
  const { isDarkMode } = useDarkMode();

  const leftFeatures = [
    {
      icon: <FaRocket />,
      title: "تعلم سريع",
      description: "محتوى تعليمي متطور ومتسارع"
    },
    {
      icon: <FaGraduationCap />,
      title: "دروس تفاعلية",
      description: "أكثر من 1000 درس تفاعلي"
    },
    {
      icon: <FaUsers />,
      title: "معلمين محترفين",
      description: "فريق من أفضل المعلمين"
    }
  ];

  const rightFeatures = [
    {
      icon: <FaBrain />,
      title: "ذكاء اصطناعي",
      description: "تقنيات حديثة في التعليم"
    },
    {
      icon: <FaGlobe />,
      title: "متاح في كل مكان",
      description: "تعلم من أي مكان وفي أي وقت"
    }
  ];

  return (
    <section className="mobile-ads-store">
      <div className="mobile-ads-store-container">
        {/* خلفية متحركة */}
        <div className="mobile-ads-store-background">
          <div className="mobile-ads-store-floating-shapes">
            <div className="mobile-ads-store-shape mobile-ads-store-shape-1"></div>
            <div className="mobile-ads-store-shape mobile-ads-store-shape-2"></div>
            <div className="mobile-ads-store-shape mobile-ads-store-shape-3"></div>
            <div className="mobile-ads-store-shape mobile-ads-store-shape-4"></div>
            <div className="mobile-ads-store-shape mobile-ads-store-shape-5"></div>
          </div>
        </div>

        {/* المحتوى الرئيسي */}
        <div className="mobile-ads-store-content">
          {/* الجانب الأيسر - النص والمميزات */}
          <div className="mobile-ads-store-left">
            <div className="mobile-ads-store-header">
              <div className="mobile-ads-store-badge">
                <FaDownload />
                <span>تطبيق جديد</span>
              </div>
              <h2 className="mobile-ads-store-title">
                حمل تطبيق <span className="mobile-ads-store-highlight" style={{ fontSize: "30px" }}>علمني</span> الآن
              </h2>
              <p className="mobile-ads-store-subtitle">
                انضم إلى آلاف الطلاب الذين يطورون مهاراتهم مع أفضل منصة تعليمية في الوطن العربي
              </p>
            </div>

            {/* المميزات */}
            <div className="mobile-ads-store-features">
              {leftFeatures.map((feature, index) => (
                <div key={index} className="mobile-ads-store-feature">
                  <div className="mobile-ads-store-feature-icon">
                    {feature.icon}
                  </div>
                  <div className="mobile-ads-store-feature-content">
                    <h3 className="mobile-ads-store-feature-title">{feature.title}</h3>
                    <p className="mobile-ads-store-feature-description">{feature.description}</p>
                  </div>
                </div>
              ))}
            </div>

            {/* أزرار التحميل */}
            <div className="mobile-ads-store-downloads">
              <div className="mobile-ads-store-download-buttons">
                <a
                  href="https://play.google.com/store/apps/details?id=tech.brmja.aalmny"
                  className="mobile-ads-store-download-btn mobile-ads-store-google-play"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="mobile-ads-store-btn-content">
                    <FaGooglePlay className="mobile-ads-store-btn-icon" />
                    <div className="mobile-ads-store-btn-text mx-2">
                      <span className="mobile-ads-store-btn-label">احصل عليه على</span>
                      <span className="mobile-ads-store-btn-platform">Google Play</span>
                    </div>
                  </div>
                  <div className="mobile-ads-store-btn-glow"></div>
                </a>

                <a
                  href="https://apps.apple.com/eg/app/%D9%85%D9%86%D8%B5%D8%A9-%D8%B9%D9%84%D9%85%D9%86%D9%8A/id6749156990"
                  className="mobile-ads-store-download-btn mobile-ads-store-app-store"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="mobile-ads-store-btn-content">
                    <FaApple className="mobile-ads-store-btn-icon" />
                    <div className="mobile-ads-store-btn-text mx-2">
                      <span className="mobile-ads-store-btn-label">تحميل من</span>
                      <span className="mobile-ads-store-btn-platform">App Store</span>
                    </div>
                  </div>
                  <div className="mobile-ads-store-btn-glow"></div>
                </a>
              </div>
            </div>


          </div>

          {/* الجانب الأيمن - المميزات والموبايل */}
          <div className="mobile-ads-store-right">
            {/* المميزات الإضافية */}
            <div className="mobile-ads-store-right-features">
              {rightFeatures.map((feature, index) => (
                <div key={index} className="mobile-ads-store-feature">
                  <div className="mobile-ads-store-feature-icon">
                    {feature.icon}
                  </div>
                  <div className="mobile-ads-store-feature-content">
                    <h3 className="mobile-ads-store-feature-title">{feature.title}</h3>
                    <p className="mobile-ads-store-feature-description">{feature.description}</p>
                  </div>
                </div>
              ))}
            </div>

            {/* الموبايل */}
            <div className="mobile-ads-store-phone-container">
              <div className="mobile-ads-store-phone">
                <div className="mobile-ads-store-phone-screen">
                  <div className="mobile-ads-store-app-preview">
                    <div className="mobile-ads-store-app-header">
                      <div className="mobile-ads-store-app-logo">ع</div>
                      <div className="mobile-ads-store-app-title">علمني</div>
                    </div>
                    <div className="mobile-ads-store-app-content">
                      <div className="mobile-ads-store-app-feature">
                        <FaCheck />
                        <span>دروس تفاعلية</span>
                      </div>
                      <div className="mobile-ads-store-app-feature">
                        <FaCheck />
                        <span>معلمين محترفين</span>
                      </div>
                      <div className="mobile-ads-store-app-feature">
                        <FaCheck />
                        <span>تعلم من أي مكان</span>
                      </div>
                    </div>
                    <img src='/3almnyLogo.png' style={{ width: "140px", height: "40px", marginTop : "30px" }} alt='3almnyLogo' />
                  </div>
                </div>
                <div className="mobile-ads-store-phone-shadow"></div>
              </div>

              {/* تقييمات عائمة */}
              <div className="mobile-ads-store-floating-reviews">
                <div className="mobile-ads-store-review mobile-ads-store-review-1">
                  <div className="mobile-ads-store-review-stars">
                    <FaStar />
                    <FaStar />
                    <FaStar />
                    <FaStar />
                    <FaStar />
                  </div>
                  <span>"تطبيق رائع جداً!"</span>
                </div>
                <div className="mobile-ads-store-review mobile-ads-store-review-2">
                  <div className="mobile-ads-store-review-stars">
                    <FaStar />
                    <FaStar />
                    <FaStar />
                    <FaStar />
                    <FaStar />
                  </div>
                  <span>"أفضل منصة تعليمية"</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* إحصائيات */}
        <div className="mobile-ads-store-stats">
          <div className="mobile-ads-store-stat">
            <span className="mobile-ads-store-stat-number">50K+</span>
            <span className="mobile-ads-store-stat-label">طالب نشط</span>
          </div>
          <div className="mobile-ads-store-stat">
            <span className="mobile-ads-store-stat-number">1000+</span>
            <span className="mobile-ads-store-stat-label">درس تفاعلي</span>
          </div>
          <div className="mobile-ads-store-stat">
            <span className="mobile-ads-store-stat-number">4.8</span>
            <span className="mobile-ads-store-stat-label">تقييم التطبيق</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MobileAdsStore; 